import {useContext} from 'react';
import {SearchStoreContext} from 'stores/contexts/SearchStore';

export const useSearchStore = () => useContext(SearchStoreContext);
